enum SCROLL_DIRECTION {
  FORWARD,
  BACKWARD,
}

export function getNextIndex(length: number, currIndex: number, direction: SCROLL_DIRECTION) {
  if (direction === SCROLL_DIRECTION.FORWARD) {
    return currIndex + 1 < length ? currIndex + 1 : 0;
  }

  if (direction === SCROLL_DIRECTION.BACKWARD) {
    return currIndex - 1 >= 0 ? currIndex - 1 : length - 1;
  }

  return 0;
}

export function setElementActive(element: Element | null, setActive = true) {
  if (!element) return;

  if (setActive && !element.classList.contains('active')) {
    element.classList.add('active');
    return;
  }

  element.classList.remove('active');
}

export function scrollToItem(
  scroller: Element,
  currIndex: number,
  direction: SCROLL_DIRECTION,
  autoWidth: boolean,
) {
  if (!scroller) return currIndex;

  const nextIndex = getNextIndex(scroller.children.length, currIndex, direction);

  const currEle = scroller.querySelector(`.item-${currIndex}`);
  setElementActive(currEle, false);

  const nextEle = scroller.querySelector(`.item-${nextIndex}`);

  if (autoWidth) {
    scroller.setAttribute('style', `width:${nextEle?.clientWidth}px;`);
    scroller.parentElement?.setAttribute('style', `width:${nextEle?.clientWidth}px;`);
  }

  setElementActive(nextEle);
  nextEle?.scrollIntoView({ inline: 'start', behavior: 'smooth', block: 'nearest' });

  return nextIndex;
}

export function scrollToNextItem(scroller: Element | null, currIndex: number, autoWidth = false) {
  if (!scroller) return 0;
  return scrollToItem(scroller, currIndex, SCROLL_DIRECTION.FORWARD, autoWidth);
}

export function scrollToPrevItem(scroller: Element | null, currIndex: number, autoWidth = false) {
  if (!scroller) return 0;
  return scrollToItem(scroller, currIndex, SCROLL_DIRECTION.BACKWARD, autoWidth);
}

export function resizeContainerWidths(width: number | string | undefined, containers: Element[]) {
  if (!width) return;
  const formattedWidth = `${typeof width === 'string' ? width : `${width}px`}`;
  containers.forEach((container) => {
    container.setAttribute('style', `width: ${formattedWidth}`);
  });
}
